import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-bird-loader',
  templateUrl: './bird-loader.component.html',
  styleUrls: ['./bird-loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BirdLoaderComponent {
  @Input() label: string = 'Thinking';
}
